import { Navigate } from "react-router-dom";
import { usePlatformAuth } from "../context/platformAuth";

export function PlatformProtectedRoute({
  children,
  redirectTo = "/sys/login",
}: {
  children: React.ReactElement;
  redirectTo?: string;
}) {
  const { token, isLoading } = usePlatformAuth();
  if (isLoading) {
    return <div className="p-6">Loading...</div>;
  }
  if (!token) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

